import axios from 'axios';
import { getFullBaseUrl } from './api-config';
import { TokenType } from '../enums/token-type';
import TokenService from '../services/tokenService';
import store from '../redux/store';
import { getPublicToken, logout } from '../redux/slices/authSlice';
import { clearCurrentUser } from '../redux/slices/userSlice';

const axiosInstance = axios.create({
  baseURL: getFullBaseUrl(),
  timeout: 30000, // 30 saniye
});

// Refresh token isteği için özel instance (interceptor olmadan)
const refreshAxiosInstance = axios.create({
  baseURL: getFullBaseUrl(),
  timeout: 30000,
});

let isGettingPublicToken = false;

axiosInstance.interceptors.request.use(
  async (config) => {
    var token = TokenService.getToken();
    var tokenType = TokenService.getTokenType();

    // Signin sayfasında otomatik public token alma
    const isSigninPage = window.location.pathname === '/signin';
    const shouldGetPublicToken =
      !isSigninPage &&
      token === null &&
      !isGettingPublicToken &&
      !config.url.includes('/auth/public-token') &&
      !config.url.includes('/auth/login');

    if (shouldGetPublicToken) {
      isGettingPublicToken = true;
      await store.dispatch(getPublicToken());
      isGettingPublicToken = false;
      token = TokenService.getToken();
      tokenType = TokenService.getTokenType();
    }

    if (token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    var tokenType = TokenService.getTokenType();

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (originalRequest.url && originalRequest.url.includes('auth/refresh-token')) {
        TokenService.removeToken();
        if (tokenType === TokenType.User) {
          store.dispatch(logout());
          store.dispatch(clearCurrentUser());
          window.location.replace('/signin');
        }
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      var token = TokenService.getToken();

      try {
        if (token) {
          const response = await refreshAxiosInstance.post('/auth/refresh-token', {
            token: token,
            tokenType: tokenType,
          });

          if (response.data === null || JSON.stringify(response.data || '').includes('UNAUTHORIZED')) {
            TokenService.removeToken();
            if (tokenType === TokenType.User) {
              store.dispatch(logout());
              store.dispatch(clearCurrentUser());
              window.location.replace('/signin');
            }
            return Promise.reject(error);
          }

          if (!response.data?.token) {
            TokenService.removeToken();
            if (tokenType === TokenType.User) {
              store.dispatch(logout());
              store.dispatch(clearCurrentUser());
              window.location.replace('/signin');
            }
            return Promise.reject(error);
          }

          const newToken = response.data.token;

          TokenService.setToken(tokenType, newToken);

          originalRequest.headers.Authorization = `Bearer ${newToken}`;

          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        TokenService.removeToken();
        if (tokenType === TokenType.User) {
          store.dispatch(logout());
          store.dispatch(clearCurrentUser());
          window.location.replace('/signin');
        }
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
